import { Table } from 'antd'
import { FC, useMemo } from 'react'
import { useGetRewindJobsQuery } from '../../../../../store/api/rewind-jobs-api'
import Machine from '../../../../../types/api/machine'
import { rewindJobsQuery } from '../../constants/query-params'
import { getRewindRowClassName } from '../../helpers/get-rewind-row-class-name'
import RewindQueueTableWrapper from '../rewind-queue-table-wrapper'
import { getColumns } from './columns'

interface RewindJobsProps {
    machines: Machine[]
}

const RewindJobs: FC<RewindJobsProps> = ({ machines }) => {
    const { data, isLoading } = useGetRewindJobsQuery(rewindJobsQuery)
    const columns = useMemo(() => getColumns(machines), [machines])

    return (
        <RewindQueueTableWrapper tableHasNotPagination>
            <Table
                dataSource={data?.data || []}
                columns={columns}
                pagination={false}
                rowKey='id'
                size='small'
                loading={isLoading}
                rowClassName={getRewindRowClassName}
            />
        </RewindQueueTableWrapper>
    )
}

export default RewindJobs
